import Head from 'next/head'
import { BaseLayout } from '~/src/components/shared/layout'
import { PageMetaBanner } from '~/src/components/shared'

import { getTitle } from '~/src/utils'
import { ConnectContent } from '~/src/components/connect' 
import { PageMetaContextProvider } from '~/src/contexts'
import { PageId } from '~/src/generated/graphql'

export default function ConnectPage() {

  return (
    <BaseLayout>
      <Head>
        <title>{getTitle('CONNECT')}</title>
      </Head>
      <PageMetaContextProvider pageId={PageId.Connect}>
        <PageMetaBanner />
        <ConnectContent />
      </PageMetaContextProvider>
    </BaseLayout>
  )
}